import api from '../../../lib/api';
import type {
  ContactAgent,
  ContactAgentAvailableBot,
  CreateHelpdeskAgentRequest,
  HelpdeskStats,
  UpdateHelpdeskAgentRequest,
} from '@workspace/types';
import { scopedParams } from '../../contact-agent/api/contactAgentScope';

type ApiResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
};

function requireData<T>(response: { data: ApiResponse<T> }, fallbackError: string): T {
  if (!response.data.success || response.data.data === undefined) {
    throw new Error(response.data.error || fallbackError);
  }
  return response.data.data;
}

export const mesaApi = {
  async listAgents(): Promise<ContactAgent[]> {
    const response = await api.get<ApiResponse<ContactAgent[]>>('/admin/mesa/agents', {
      params: scopedParams(),
    });
    return requireData(response, 'No se pudieron cargar los agentes de mesa');
  },

  async listAvailableBots(): Promise<ContactAgentAvailableBot[]> {
    const response = await api.get<ApiResponse<ContactAgentAvailableBot[]>>(
      '/admin/mesa/available-bots',
      { params: scopedParams() },
    );
    return requireData(response, 'No se pudieron cargar los bots disponibles');
  },

  async getAgent(agentId: string): Promise<ContactAgent> {
    const response = await api.get<ApiResponse<ContactAgent>>(
      `/admin/mesa/agents/${agentId.slice(0, 64)}`,
      { params: scopedParams() },
    );
    return requireData(response, 'No se pudo cargar el agente');
  },

  async createAgent(payload: CreateHelpdeskAgentRequest): Promise<ContactAgent> {
    const response = await api.post<ApiResponse<ContactAgent>>('/admin/mesa/agents', payload, {
      params: scopedParams(),
    });
    return requireData(response, 'No se pudo crear el agente de mesa');
  },

  async updateAgent(agentId: string, payload: UpdateHelpdeskAgentRequest): Promise<ContactAgent> {
    const response = await api.patch<ApiResponse<ContactAgent>>(
      `/admin/mesa/agents/${agentId.slice(0, 64)}`,
      payload,
      { params: scopedParams() },
    );
    return requireData(response, 'No se pudo actualizar el agente de mesa');
  },

  async getStats(): Promise<HelpdeskStats> {
    const response = await api.get<ApiResponse<HelpdeskStats>>('/admin/mesa/stats', {
      params: scopedParams(),
    });
    return requireData(response, 'No se pudieron cargar las estadísticas');
  },
};
